import { Pipe, PipeTransform, SecurityContext, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safeResourceUrl',
})
export class SafeResourceUrlPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(url: string): SafeResourceUrl {
    let sanitized: string | null = null;
    try {
      sanitized = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, url);
    } catch {
      sanitized = this.sanitizer.sanitize(SecurityContext.URL, url);
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(sanitized);
  }
}
